import { render, staticRenderFns } from "./TipoDocumento.vue?vue&type=template&id=9813f278&scoped=true&lang=pug"
import script from "./TipoDocumento.vue?vue&type=script&lang=js"
export * from "./TipoDocumento.vue?vue&type=script&lang=js"
import style0 from "./TipoDocumento.vue?vue&type=style&index=0&id=9813f278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9813f278",
  null
  
)

export default component.exports